/** Auswahlmodi im Ruhezeit-Formular (UI-Zustand, nicht gespeichert). */
export const REST_FEE_MODE = { None: "none", Amount: "amount", Contributions: "contributions" } as const;
export const REST_DURATION_RULE_MODE = { None: "none", MinimumDuration: "minimumDuration", FullPeriods: "fullPeriods" } as const;

/** Abrechnungsmodell „freie Zeit ans Ende anhängen“ (zusätzlich zu den Zeitplanmodi des Modells). */
export const REST_BILLING_APPEND_FREE_TO_END = "appendFreeToEnd";

/** Platzhalterwert der Vorlagenauswahl für eine individuelle Ruhezeit ohne Vorlage. */
export const REST_PERIOD_TEMPLATE_CUSTOM = "__custom__";
